import { IProps as IMultiEditingProps } from "@routes/private/Editor/Editor/Pickers/MultiEditingPicker/types";

export const compareMultiEditingProps = (prevProps: IMultiEditingProps, nextProps: IMultiEditingProps) => {
  const justPrevValues = [
    prevProps.data,
    prevProps.multiEditingConfig,
    {...prevProps.editorStatus, overElementId: ""},
    prevProps.selectDescribe,
  ];
  const justNextValues = [
    nextProps.data,
    nextProps.multiEditingConfig,
    {...nextProps.editorStatus, overElementId: ""},
    nextProps.selectDescribe,
  ];
  return JSON.stringify(justPrevValues) === JSON.stringify(justNextValues);
}